import { useKeyMetrics } from '../../hooks/useKeyMetrics';
import { formatCurrency } from '../../utils/format';
import { KeyMetricsCard } from './KeyMetricsCard';

export function KeyMetricsSection() {
  const metrics = useKeyMetrics();

  const formatPercentage = (value: number): string => {
    return `${value.toFixed(0)}%`;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <KeyMetricsCard
        title="Gasto total"
        value={formatCurrency(metrics.totalSpend)}
        change={metrics.comparison.totalSpendChange}
        subtitle="vs mes anterior"
        testId="total-spend"
      />
      <KeyMetricsCard
        title="Promedio diario"
        value={formatCurrency(metrics.dailyAverage)}
        change={metrics.comparison.dailyAverageChange}
        subtitle="vs mes anterior"
        testId="daily-average"
      />
      {metrics.projectedMonthEnd !== null && (
        <KeyMetricsCard
          title="Proyección fin de mes"
          value={formatCurrency(metrics.projectedMonthEnd)}
          change={metrics.comparison.projectedMonthEndChange}
          subtitle="vs mes anterior"
          testId="projected-month-end"
        />
      )}
      {metrics.largestCategory && (
        <KeyMetricsCard
          title="Mayor categoría"
          value={metrics.largestCategory.name}
          subtitle={formatPercentage(metrics.largestCategory.percentage)}
          testId="largest-category"
        />
      )}
    </div>
  );
}
